export default function PlusIcon({ width="0.8rem", stroke }) {
  return (
    <svg
      width={width}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.99996 1.16666V12.8333M1.16663 7H12.8333"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
